module.exports = __webpack_public_path__ + "img/member_list_3.9f5b66b3.png";